import React, { useState } from 'react';
import { ArrowLeft, AlertTriangle, CheckCircle, Clock, Eye, Edit, Upload, ExternalLink, MessageSquare, User, Calendar, Shield, FileText, Link, Flag, Check, X, RotateCcw, PenTool, AlertCircle, ChevronDown, Bot, Send, Copy, Download, GitBranch, Zap, Target, DollarSign, Save, Plus, Trash2, Image, File, ChevronUp } from 'lucide-react';
import { Header } from '../components/Header';
export function ClaimReview() {
  const [selectedVersion, setSelectedVersion] = useState('v1.3');
  const [newComment, setNewComment] = useState('');
  const [selectedResolution, setSelectedResolution] = useState('');
  const [aiQuestion, setAiQuestion] = useState('');
  const [isEditingDraft, setIsEditingDraft] = useState(false);
  const [draftText, setDraftText] = useState('Contains 2000% Daily Value of Vitamin C');
  const [isEditingUsedOn, setIsEditingUsedOn] = useState(false);
  const [usedOnPlatforms, setUsedOnPlatforms] = useState(['Label', 'Website', 'Amazon listing']);
  const [newLink, setNewLink] = useState('');
  const [showAddLink, setShowAddLink] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([{
    id: 1,
    name: 'FDA_Vitamin_C_Guidelines.pdf',
    type: 'pdf',
    size: '2.4 MB',
    uploadedBy: 'Sarah Chen',
    uploadedAt: '2024-01-14'
  }, {
    id: 2,
    name: 'competitor_analysis.jpg',
    type: 'image',
    size: '1.2 MB',
    uploadedBy: 'Marketing Team',
    uploadedAt: '2024-01-13'
  }]);
  const [supportingLinks, setSupportingLinks] = useState([{
    id: 1,
    url: 'https://www.fda.gov/food/food-labeling-nutrition/nutrition-labeling-guide',
    title: 'FDA Nutrition Labeling Guide',
    addedBy: 'Legal Team',
    addedAt: '2024-01-12'
  }, {
    id: 2,
    url: 'https://competitor.com/vitamin-c-supplement',
    title: 'Competitor Vitamin C Claims',
    addedBy: 'Marketing Team',
    addedAt: '2024-01-11'
  }]);
  const aiMessages = [{
    id: 1,
    type: 'assistant',
    message: "Hi! I'm Clara, your AI Claims Assistant. I can help you with FDA regulations, similar claims, and compliance questions. What would you like to know?",
    timestamp: '9:00 AM'
  }];
  const availablePlatforms = ['Label', 'Website', 'Amazon listing', 'Marketing materials', 'Social media', 'Email campaigns', 'Print ads', 'Retail displays', 'Product packaging', 'Brochures'];
  const claim = {
    id: 1,
    title: 'Contains 2000% Daily Value of Vitamin C',
    type: 'Nutrient Content',
    status: 'conflict',
    priority: 'high',
    riskLevel: 'high',
    currentVersion: 'v1.3',
    lastModified: {
      user: 'Sarah Chen',
      role: 'Marketing',
      date: '2024-01-15',
      time: '4:20 PM'
    }
  };
  const versions = [{
    version: 'v1.3',
    text: 'Contains 2000% Daily Value of Vitamin C',
    status: 'current',
    date: '2024-01-15'
  }, {
    version: 'v1.2',
    text: 'Contains 1800% Daily Value of Vitamin C',
    status: 'draft',
    date: '2024-01-15'
  }, {
    version: 'v1.1',
    text: 'Contains 2000% Daily Value of Vitamin C',
    status: 'flagged',
    date: '2024-01-14'
  }, {
    version: 'v1.0',
    text: 'Contains 2000% Daily Value of Vitamin C',
    status: 'created',
    date: '2024-01-13'
  }];
  // Reversed timeline - latest first
  const timeline = [{
    id: 4,
    version: 'v1.3',
    action: 'Revised Draft',
    user: 'Sarah Chen',
    role: 'Marketing',
    date: '2024-01-15',
    time: '4:20 PM',
    comment: 'Reverted to 2000% for campaign consistency',
    status: 'current'
  }, {
    id: 3,
    version: 'v1.2',
    action: 'Updated Draft',
    user: 'Sarah Chen',
    role: 'Marketing',
    date: '2024-01-15',
    time: '2:30 PM',
    comment: 'Reduced to 1800% based on regulatory feedback',
    status: 'updated'
  }, {
    id: 2,
    version: 'v1.1',
    action: 'Conflict Detected',
    user: 'System',
    role: 'Automated',
    date: '2024-01-14',
    time: '2:15 PM',
    comment: 'BOM validation failed - percentage mismatch detected',
    status: 'flagged'
  }, {
    id: 1,
    version: 'v1.0',
    action: 'Created',
    user: 'Sarah Chen',
    role: 'Marketing',
    date: '2024-01-13',
    time: '10:30 AM',
    comment: 'Initial claim for Q1 marketing campaign',
    status: 'created'
  }];
  const aiSuggestions = [{
    id: 1,
    title: 'Update claim to match BOM',
    description: 'Change to "Contains 556% Daily Value of Vitamin C"',
    impact: 'Low',
    effort: 'Minimal',
    recommended: true,
    icon: <Check className="w-4 h-4 text-green-600" data-id="element-28" />
  }, {
    id: 2,
    title: 'Increase Vitamin C formulation',
    description: 'Reformulate to 1800mg Vitamin C (2000% DV)',
    impact: 'High',
    effort: 'Significant',
    recommended: false,
    icon: <AlertTriangle className="w-4 h-4 text-yellow-600" data-id="element-29" />
  }, {
    id: 3,
    title: 'Use general wellness claim',
    description: 'Replace with "High in Vitamin C" without percentage',
    impact: 'Medium',
    effort: 'Moderate',
    recommended: false,
    icon: <X className="w-4 h-4 text-red-600" data-id="element-30" />
  }];
  const quickQuestions = ["What's the FDA requirement for nutrient content claims?", 'Show me similar approved claims', 'What documentation is needed?', 'How long does regulatory review take?'];
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'conflict':
        return <AlertTriangle className="w-5 h-5 text-red-600" data-id="element-31" />;
      case 'current':
        return <CheckCircle className="w-5 h-5 text-green-600" data-id="element-32" />;
      case 'flagged':
        return <AlertTriangle className="w-5 h-5 text-red-600" data-id="element-33" />;
      case 'created':
        return <User className="w-5 h-5 text-blue-600" data-id="element-34" />;
      default:
        return <Clock className="w-5 h-5 text-gray-600" data-id="element-35" />;
    }
  };
  const getRiskColor = (risk: string) => {
    switch (risk) {
      case 'high':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'medium':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'low':
        return 'bg-green-100 text-green-800 border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'pdf':
        return <FileText className="w-4 h-4 text-red-600" data-id="element-36" />;
      case 'image':
        return <Image className="w-4 h-4 text-blue-600" data-id="element-37" />;
      default:
        return <File className="w-4 h-4 text-gray-600" data-id="element-38" />;
    }
  };
  const sendAiMessage = () => {
    if (!aiQuestion.trim()) return;
    const newMessage = {
      id: aiMessages.length + 1,
      type: 'user',
      message: aiQuestion,
      timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    const aiResponse = {
      id: aiMessages.length + 2,
      type: 'assistant',
      message: 'Based on FDA regulations, nutrient content claims must be substantiated by actual product content. For Vitamin C, claims cannot exceed analyzed values by more than 20%. I recommend updating your claim to match the current BOM formulation.',
      timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setAiMessages([...aiMessages, newMessage, aiResponse]);
    setAiQuestion('');
  };
  const saveDraft = () => {
    setIsEditingDraft(false);
    console.log('Saving draft:', draftText);
  };
  const togglePlatform = (platform: string) => {
    if (usedOnPlatforms.includes(platform)) {
      setUsedOnPlatforms(usedOnPlatforms.filter(p => p !== platform));
    } else {
      setUsedOnPlatforms([...usedOnPlatforms, platform]);
    }
  };
  const saveUsedOn = () => {
    setIsEditingUsedOn(false);
    console.log('Saving used on platforms:', usedOnPlatforms);
  };
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      Array.from(files).forEach(file => {
        const newFile = {
          id: uploadedFiles.length + 1,
          name: file.name,
          type: file.type.includes('image') ? 'image' : file.type.includes('pdf') ? 'pdf' : 'file',
          size: `${(file.size / 1024 / 1024).toFixed(1)} MB`,
          uploadedBy: 'Sarah Chen',
          uploadedAt: new Date().toISOString().split('T')[0]
        };
        setUploadedFiles([...uploadedFiles, newFile]);
      });
    }
  };
  const addLink = () => {
    if (newLink.trim()) {
      const link = {
        id: supportingLinks.length + 1,
        url: newLink,
        title: newLink.length > 50 ? newLink.substring(0, 50) + '...' : newLink,
        addedBy: 'Sarah Chen',
        addedAt: new Date().toISOString().split('T')[0]
      };
      setSupportingLinks([...supportingLinks, link]);
      setNewLink('');
      setShowAddLink(false);
    }
  };
  const removeFile = (id: number) => {
    setUploadedFiles(uploadedFiles.filter(file => file.id !== id));
  };
  const removeLink = (id: number) => {
    setSupportingLinks(supportingLinks.filter(link => link.id !== id));
  };
  // Add new state for tab management
  const [activeTab, setActiveTab] = useState('details');
  // Add product data
  const products = [{
    id: 'AMV60-001',
    name: 'Advanced Multivitamin 60ct',
    type: 'Item SKU',
    status: 'Active',
    platforms: ['Label', 'Website'],
    image: 'https://placehold.co/80x80'
  }, {
    id: 'AMV120-001',
    name: 'Advanced Multivitamin 120ct',
    type: 'Item SKU',
    status: 'Active',
    platforms: ['Label', 'Website'],
    image: 'https://placehold.co/80x80'
  }, {
    id: 'CSE12-AMV60',
    name: 'Advanced Multivitamin 60ct (12-pack)',
    type: 'Case SKU',
    status: 'Active',
    platforms: ['Amazon'],
    image: 'https://placehold.co/80x80'
  }, {
    id: 'CSE6-AMV120',
    name: 'Advanced Multivitamin 120ct (6-pack)',
    type: 'Case SKU',
    status: 'Active',
    platforms: ['Amazon'],
    image: 'https://placehold.co/80x80'
  }];
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-39">
      <Header data-id="element-40" />
      {/* Page Header */}
      <div className="bg-white border-b border-gray-200" data-id="element-41">
        <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-42">
          {/* Breadcrumb */}
          <div className="flex items-center space-x-2 mb-4 text-sm text-gray-600" data-id="element-43">
            <button className="hover:text-gray-900" data-id="element-44">Claims</button>
            <span data-id="element-45">›</span>
            <span className="text-purple-600 font-medium" data-id="element-46">CLM-2881</span>
          </div>
          <div className="flex items-start justify-between" data-id="element-47">
            <div className="flex-1" data-id="element-48">
              <div className="flex items-center space-x-4 mb-3" data-id="element-49">
                <button className="flex items-center space-x-2 text-gray-600 hover:text-gray-900" data-id="element-50">
                  <ArrowLeft className="w-4 h-4" data-id="element-51" />
                  <span data-id="element-52">Back to Claims Validation</span>
                </button>
              </div>

              <div className="flex items-center space-x-3 mb-4" data-id="element-53">
                <span className="bg-red-100 text-red-800 border border-red-200 px-3 py-1 rounded-full text-sm font-medium" data-id="element-54">
                  CONFLICT
                </span>
                <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getRiskColor(claim.riskLevel)}`} data-id="element-55">
                  {claim.riskLevel.toUpperCase()} RISK
                </span>
                <span className="bg-blue-100 text-blue-800 border border-blue-200 px-3 py-1 rounded-full text-sm font-medium" data-id="element-56">
                  {claim.type.toUpperCase()}
                </span>
              </div>
              {/* Version Selector */}
              <div className="flex items-center space-x-4" data-id="element-57">
                <div className="relative" data-id="element-58">
                  <select value={selectedVersion} onChange={e => setSelectedVersion(e.target.value)} className="appearance-none bg-white border border-gray-200 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-59">
                    {versions.map(version => <option key={version.version} value={version.version} data-id="element-60">
                        {version.version} -{' '}
                        {version.status === 'current' ? 'Current Draft' : version.status}
                      </option>)}
                  </select>
                  <ChevronDown className="w-4 h-4 absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-61" />
                </div>
                <span className="text-sm text-gray-600" data-id="element-62">
                  Last modified by {claim.lastModified.user} -{' '}
                  {claim.lastModified.date}, {claim.lastModified.time}
                </span>
              </div>
            </div>
            <div className="flex items-center space-x-3" data-id="element-63">
              <button disabled className="bg-green-100 text-green-600 px-4 py-2 rounded-lg cursor-not-allowed flex items-center space-x-2" data-id="element-64">
                <Check className="w-4 h-4" data-id="element-65" />
                <span data-id="element-66">Approve</span>
              </button>
              <button className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 flex items-center space-x-2" data-id="element-67">
                <RotateCcw className="w-4 h-4" data-id="element-68" />
                <span data-id="element-69">Request Review</span>
              </button>
              <button className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 flex items-center space-x-2" data-id="element-70">
                <X className="w-4 h-4" data-id="element-71" />
                <span data-id="element-72">Reject</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <main className="max-w-7xl mx-auto px-6 py-6" data-id="element-73">
        <div className="grid grid-cols-10 gap-6" data-id="element-74">
          {/* Main Content - 70% width */}
          <div className="col-span-7 space-y-6" data-id="element-75">
            {/* Tabs */}
            <div className="bg-white rounded-lg border" data-id="element-76">
              <div className="border-b border-gray-200" data-id="element-77">
                <nav className="flex -mb-px" data-id="element-78">
                  <button onClick={() => setActiveTab('details')} className={`py-4 px-6 inline-flex items-center border-b-2 font-medium text-sm ${activeTab === 'details' ? 'border-purple-500 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-79">
                    Claim Details
                  </button>
                  <button onClick={() => setActiveTab('products')} className={`py-4 px-6 inline-flex items-center border-b-2 font-medium text-sm ${activeTab === 'products' ? 'border-purple-500 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-80">
                    Products
                  </button>
                  <button onClick={() => setActiveTab('activity')} className={`py-4 px-6 inline-flex items-center border-b-2 font-medium text-sm ${activeTab === 'activity' ? 'border-purple-500 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-81">
                    Timeline & Activity
                  </button>
                </nav>
              </div>
              <div className="p-6" data-id="element-82">
                {/* Details Tab */}
                {activeTab === 'details' && <div className="space-y-6" data-id="element-83">
                    {/* Current Draft Panel */}
                    <div className="border-b border-gray-200 pb-6" data-id="element-84">
                      <div className="flex items-center justify-between mb-4" data-id="element-85">
                        <h3 className="text-lg font-semibold text-gray-900" data-id="element-86">
                          Current Draft
                        </h3>
                        <div className="flex items-center space-x-2" data-id="element-87">
                          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-88">
                            {selectedVersion} - Draft
                          </span>
                          {!isEditingDraft && <button onClick={() => setIsEditingDraft(true)} className="flex items-center space-x-1 px-3 py-1 text-purple-600 hover:text-purple-700 text-sm font-medium" data-id="element-89">
                              <Edit className="w-4 h-4" data-id="element-90" />
                              <span data-id="element-91">Edit</span>
                            </button>}
                        </div>
                      </div>
                      {/* Current draft content */}
                      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-4" data-id="element-92">
                        {isEditingDraft ? <div className="space-y-4" data-id="element-93">
                            <textarea value={draftText} onChange={e => setDraftText(e.target.value)} className="w-full p-3 text-lg font-medium border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 resize-none" rows={2} data-id="element-94" />
                            <div className="flex items-center space-x-2" data-id="element-95">
                              <button onClick={saveDraft} className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center space-x-2 text-sm" data-id="element-96">
                                <Save className="w-4 h-4" data-id="element-97" />
                                <span data-id="element-98">Save Draft</span>
                              </button>
                              <button onClick={() => setIsEditingDraft(false)} className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 text-sm" data-id="element-99">
                                Cancel
                              </button>
                            </div>
                          </div> : <>
                            <p className="text-lg font-medium text-gray-900 mb-2" data-id="element-100">
                              {versions.find(v => v.version === selectedVersion)?.text}
                            </p>
                            <div className="text-sm text-gray-600" data-id="element-101">
                              <p data-id="element-102">
                                Change from v1.2: Updated percentage from 1800%
                                to 2000%
                              </p>
                            </div>
                          </>}
                      </div>
                      {/* Used on platforms */}
                      <div className="flex items-center space-x-4 text-sm text-gray-600" data-id="element-103">
                        <div className="flex items-center space-x-2" data-id="element-104">
                          <span data-id="element-105">Used on:</span>
                          {!isEditingUsedOn ? <>
                              <span data-id="element-106">{usedOnPlatforms.join(', ')}</span>
                              <button onClick={() => setIsEditingUsedOn(true)} className="text-purple-600 hover:text-purple-700" data-id="element-107">
                                <Edit className="w-3 h-3" data-id="element-108" />
                              </button>
                            </> : <div className="flex-1" data-id="element-109">
                              <div className="relative" data-id="element-110">
                                <div className="border border-gray-200 rounded-lg p-2 bg-white max-h-32 overflow-y-auto" data-id="element-111">
                                  {availablePlatforms.map(platform => <label key={platform} className="flex items-center space-x-2 p-1 hover:bg-gray-50 rounded text-sm" data-id="element-112">
                                      <input type="checkbox" checked={usedOnPlatforms.includes(platform)} onChange={() => togglePlatform(platform)} className="rounded border-gray-300 text-purple-600 focus:ring-purple-500" data-id="element-113" />
                                      <span data-id="element-114">{platform}</span>
                                    </label>)}
                                </div>
                                <div className="flex items-center space-x-2 mt-2" data-id="element-115">
                                  <button onClick={saveUsedOn} className="bg-purple-600 text-white px-3 py-1 rounded text-sm hover:bg-purple-700" data-id="element-116">
                                    Save
                                  </button>
                                  <button onClick={() => setIsEditingUsedOn(false)} className="bg-gray-500 text-white px-3 py-1 rounded text-sm hover:bg-gray-600" data-id="element-117">
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>}
                        </div>
                        <span data-id="element-118">•</span>
                        <span data-id="element-119">Type: {claim.type}</span>
                        <span data-id="element-120">•</span>
                        <span data-id="element-121">Priority: {claim.priority}</span>
                      </div>
                    </div>
                    {/* Supporting Evidence Section */}
                    <div data-id="element-122">
                      <h4 className="font-medium text-gray-900 mb-3" data-id="element-123">
                        Supporting Evidence
                      </h4>
                      {/* File Upload */}
                      <div className="mb-4" data-id="element-124">
                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-gray-400 transition-colors" data-id="element-125">
                          <Upload className="w-6 h-6 text-gray-400 mx-auto mb-2" data-id="element-126" />
                          <p className="text-sm text-gray-600 mb-2" data-id="element-127">
                            Upload studies, certificates, images, or other
                            documentation
                          </p>
                          <input type="file" multiple onChange={handleFileUpload} className="hidden" id="file-upload" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" data-id="element-128" />
                          <label htmlFor="file-upload" className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 cursor-pointer text-sm" data-id="element-129">
                            Choose Files
                          </label>
                        </div>
                      </div>
                      {/* Uploaded Files */}
                      {uploadedFiles.length > 0 && <div className="mb-4" data-id="element-130">
                          <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-131">
                            Uploaded Files
                          </h5>
                          <div className="space-y-2" data-id="element-132">
                            {uploadedFiles.map(file => <div key={file.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-133">
                                <div className="flex items-center space-x-3" data-id="element-134">
                                  {getFileIcon(file.type)}
                                  <div data-id="element-135">
                                    <p className="text-sm font-medium text-gray-900" data-id="element-136">
                                      {file.name}
                                    </p>
                                    <p className="text-xs text-gray-500" data-id="element-137">
                                      {file.size} • Uploaded by{' '}
                                      {file.uploadedBy} on {file.uploadedAt}
                                    </p>
                                  </div>
                                </div>
                                <div className="flex items-center space-x-2" data-id="element-138">
                                  <button className="text-blue-600 hover:text-blue-700" data-id="element-139">
                                    <Eye className="w-4 h-4" data-id="element-140" />
                                  </button>
                                  <button onClick={() => removeFile(file.id)} className="text-red-600 hover:text-red-700" data-id="element-141">
                                    <Trash2 className="w-4 h-4" data-id="element-142" />
                                  </button>
                                </div>
                              </div>)}
                          </div>
                        </div>}
                      {/* Add Links */}
                      <div data-id="element-143">
                        <div className="flex items-center justify-between mb-2" data-id="element-144">
                          <h5 className="text-sm font-medium text-gray-700" data-id="element-145">
                            Reference Links
                          </h5>
                          <button onClick={() => setShowAddLink(!showAddLink)} className="flex items-center space-x-1 text-purple-600 hover:text-purple-700 text-sm" data-id="element-146">
                            <Plus className="w-4 h-4" data-id="element-147" />
                            <span data-id="element-148">Add Link</span>
                          </button>
                        </div>
                        {showAddLink && <div className="mb-3 p-3 border border-gray-200 rounded-lg bg-gray-50" data-id="element-149">
                            <div className="flex space-x-2" data-id="element-150">
                              <input type="url" value={newLink} onChange={e => setNewLink(e.target.value)} placeholder="Enter URL (FDA guidelines, competitor sites, etc.)" className="flex-1 p-2 text-sm border border-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-151" />
                              <button onClick={addLink} className="bg-purple-600 text-white px-3 py-2 rounded hover:bg-purple-700 text-sm" data-id="element-152">
                                Add
                              </button>
                              <button onClick={() => setShowAddLink(false)} className="bg-gray-500 text-white px-3 py-2 rounded hover:bg-gray-600 text-sm" data-id="element-153">
                                Cancel
                              </button>
                            </div>
                          </div>}
                        {/* Supporting Links */}
                        {supportingLinks.length > 0 && <div className="space-y-2" data-id="element-154">
                            {supportingLinks.map(link => <div key={link.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-155">
                                <div className="flex items-center space-x-3" data-id="element-156">
                                  <Link className="w-4 h-4 text-blue-600" data-id="element-157" />
                                  <div data-id="element-158">
                                    <p className="text-sm font-medium text-gray-900" data-id="element-159">
                                      {link.title}
                                    </p>
                                    <p className="text-xs text-gray-500" data-id="element-160">
                                      Added by {link.addedBy} on {link.addedAt}
                                    </p>
                                  </div>
                                </div>
                                <div className="flex items-center space-x-2" data-id="element-161">
                                  <button className="text-blue-600 hover:text-blue-700" data-id="element-162">
                                    <ExternalLink className="w-4 h-4" data-id="element-163" />
                                  </button>
                                  <button onClick={() => removeLink(link.id)} className="text-red-600 hover:text-red-700" data-id="element-164">
                                    <Trash2 className="w-4 h-4" data-id="element-165" />
                                  </button>
                                </div>
                              </div>)}
                          </div>}
                      </div>
                    </div>
                  </div>}
                {/* Products Tab */}
                {activeTab === 'products' && <div className="space-y-6" data-id="element-166">
                    <div className="grid grid-cols-1 gap-4" data-id="element-167">
                      {products.map(product => <div key={product.id} className="flex items-start space-x-4 p-4 border border-gray-200 rounded-lg hover:bg-gray-50" data-id="element-168">
                          <img src={product.image} alt={product.name} className="w-20 h-20 rounded-lg object-cover" data-id="element-169" />
                          <div className="flex-1 min-w-0" data-id="element-170">
                            <div className="flex items-start justify-between" data-id="element-171">
                              <div data-id="element-172">
                                <h4 className="text-sm font-medium text-gray-900" data-id="element-173">
                                  {product.name}
                                </h4>
                                <p className="text-sm text-gray-500" data-id="element-174">
                                  {product.id}
                                </p>
                              </div>
                              <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${product.type === 'Item SKU' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'}`} data-id="element-175">
                                {product.type}
                              </span>
                            </div>
                            <div className="mt-2" data-id="element-176">
                              <p className="text-sm text-gray-600" data-id="element-177">
                                Used on: {product.platforms.join(', ')}
                              </p>
                            </div>
                            <div className="mt-2 flex items-center space-x-4" data-id="element-178">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-179">
                                {product.status}
                              </span>
                            </div>
                          </div>
                        </div>)}
                    </div>
                  </div>}
                {/* Activity Tab */}
                {activeTab === 'activity' && <div className="space-y-6" data-id="element-180">
                    {/* Next Step */}
                    <div className="flex items-start space-x-4" data-id="element-181">
                      <div className="flex-shrink-0 mt-1" data-id="element-182">
                        <div className="w-10 h-10 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center" data-id="element-183">
                          <Clock className="w-5 h-5 text-gray-400" data-id="element-184" />
                        </div>
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-185">
                        <div className="flex items-center space-x-2 mb-1" data-id="element-186">
                          <span className="font-medium text-gray-600" data-id="element-187">
                            Next: Pending Legal Team Review
                          </span>
                        </div>
                        <p className="text-sm text-gray-500" data-id="element-188">
                          Awaiting regulatory compliance approval
                        </p>
                      </div>
                    </div>
                    {/* Timeline items */}
                    {timeline.map((item, index) => <div key={item.id} className="flex items-start space-x-4" data-id="element-189">
                        <div className="flex-shrink-0 mt-1" data-id="element-190">
                          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${item.status === 'created' ? 'bg-blue-100' : item.status === 'flagged' ? 'bg-red-100' : item.status === 'updated' ? 'bg-yellow-100' : 'bg-green-100'}`} data-id="element-191">
                            {getStatusIcon(item.status)}
                          </div>
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-192">
                          <div className="flex items-center space-x-2 mb-1" data-id="element-193">
                            <span className="font-medium text-gray-900" data-id="element-194">
                              {item.version}
                            </span>
                            <span className="text-sm text-gray-600" data-id="element-195">
                              - {item.action}
                            </span>
                            <span className="text-xs text-gray-500" data-id="element-196">
                              by {item.user} ({item.role})
                            </span>
                          </div>
                          <p className="text-sm text-gray-700 mb-2" data-id="element-197">
                            {item.comment}
                          </p>
                          <div className="flex items-center space-x-2 text-xs text-gray-500" data-id="element-198">
                            <span data-id="element-199">{item.date}</span>
                            <span data-id="element-200">•</span>
                            <span data-id="element-201">{item.time}</span>
                          </div>
                        </div>
                        {index < timeline.length - 1 && <div className="absolute left-11 mt-12 w-px h-8 bg-gray-200" data-id="element-202" />}
                      </div>)}
                  </div>}
              </div>
            </div>
            {/* Timeline/Activity Feed */}
            <div className="bg-white rounded-lg border" data-id="element-203">
              <div className="p-6 border-b border-gray-200" data-id="element-204">
                
              </div>
              <div className="p-6" data-id="element-205">
                <div className="space-y-6" data-id="element-206">
                  {/* Next Step */}
                  <div className="flex items-start space-x-4" data-id="element-207">
                    <div className="flex-shrink-0 mt-1" data-id="element-208">
                      <div className="w-10 h-10 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center" data-id="element-209">
                        <Clock className="w-5 h-5 text-gray-400" data-id="element-210" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-211">
                      <div className="flex items-center space-x-2 mb-1" data-id="element-212">
                        <span className="font-medium text-gray-600" data-id="element-213">
                          Next: Pending Legal Team Review
                        </span>
                      </div>
                      <p className="text-sm text-gray-500" data-id="element-214">
                        Awaiting regulatory compliance approval
                      </p>
                    </div>
                  </div>
                  {timeline.map((item, index) => <div key={item.id} className="flex items-start space-x-4" data-id="element-215">
                      <div className="flex-shrink-0 mt-1" data-id="element-216">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${item.status === 'created' ? 'bg-blue-100' : item.status === 'flagged' ? 'bg-red-100' : item.status === 'updated' ? 'bg-yellow-100' : 'bg-green-100'}`} data-id="element-217">
                          {getStatusIcon(item.status)}
                        </div>
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-218">
                        <div className="flex items-center space-x-2 mb-1" data-id="element-219">
                          <span className="font-medium text-gray-900" data-id="element-220">
                            {item.version}
                          </span>
                          <span className="text-sm text-gray-600" data-id="element-221">
                            - {item.action}
                          </span>
                          <span className="text-xs text-gray-500" data-id="element-222">
                            by {item.user} ({item.role})
                          </span>
                        </div>
                        <p className="text-sm text-gray-700 mb-2" data-id="element-223">
                          {item.comment}
                        </p>
                        <div className="flex items-center space-x-2 text-xs text-gray-500" data-id="element-224">
                          <span data-id="element-225">{item.date}</span>
                          <span data-id="element-226">•</span>
                          <span data-id="element-227">{item.time}</span>
                        </div>
                      </div>
                      {index < timeline.length - 1 && <div className="absolute left-11 mt-12 w-px h-8 bg-gray-200" data-id="element-228" />}
                    </div>)}
                </div>
              </div>
            </div>
            {/* Validation Results */}
            <div className="bg-white rounded-lg border" data-id="element-229"></div>
          </div>
          {/* Right Sidebar - 30% width */}
          <div className="col-span-3 space-y-6" data-id="element-230">
            {/* AI Suggestions */}
            <div className="bg-white rounded-lg border" data-id="element-231">
              <div className="p-6 border-b border-gray-200" data-id="element-232">
                <div className="flex items-center space-x-2" data-id="element-233">
                  <Zap className="w-5 h-5 text-purple-600" data-id="element-234" />
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-235">
                    AI Recommendations
                  </h3>
                </div>
              </div>
              <div className="p-6" data-id="element-236">
                <div className="space-y-4" data-id="element-237">
                  {aiSuggestions.map(suggestion => <div key={suggestion.id} className={`border rounded-lg p-4 cursor-pointer transition-colors ${selectedResolution === suggestion.id.toString() ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-gray-300'} ${suggestion.recommended ? 'ring-2 ring-green-200' : ''}`} onClick={() => setSelectedResolution(suggestion.id.toString())} data-id="element-238">
                      <div className="flex items-start space-x-3" data-id="element-239">
                        {suggestion.icon}
                        <div className="flex-1" data-id="element-240">
                          <div className="flex items-center space-x-2 mb-1" data-id="element-241">
                            <h4 className="font-medium text-sm text-gray-900" data-id="element-242">
                              {suggestion.title}
                            </h4>
                            {suggestion.recommended && <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium" data-id="element-243">
                                Recommended
                              </span>}
                          </div>
                          <p className="text-xs text-gray-600 mb-2" data-id="element-244">
                            {suggestion.description}
                          </p>
                          <div className="flex items-center space-x-4 text-xs" data-id="element-245">
                            <div className="flex items-center space-x-1" data-id="element-246">
                              <Target className="w-3 h-3 text-gray-400" data-id="element-247" />
                              <span className="text-gray-500" data-id="element-248">
                                Impact: {suggestion.impact}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
            {/* AI Assistant Chat */}
            <div className="bg-white rounded-lg border" data-id="element-249">
              <div className="p-6 border-b border-gray-200" data-id="element-250">
                <div className="flex items-center space-x-2" data-id="element-251">
                  <Bot className="w-5 h-5 text-purple-600" data-id="element-252" />
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-253">
                    Clara - AI Claims Assistant
                  </h3>
                </div>
              </div>
              <div className="p-6" data-id="element-254">
                {/* Chat Messages */}
                <div className="h-48 overflow-y-auto mb-4 space-y-3" data-id="element-255">
                  {aiMessages.map(message => <div key={message.id} className={`flex ${message.type === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-256">
                      <div className={`max-w-xs p-3 rounded-lg text-sm ${message.type === 'user' ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-900'}`} data-id="element-257">
                        <p data-id="element-258">{message.message}</p>
                        <p className={`text-xs mt-1 ${message.type === 'user' ? 'text-purple-200' : 'text-gray-500'}`} data-id="element-259">
                          {message.timestamp}
                        </p>
                      </div>
                    </div>)}
                </div>
                {/* Quick Questions */}
                <div className="mb-4" data-id="element-260">
                  <p className="text-sm font-medium text-gray-700 mb-3" data-id="element-261">
                    Quick Questions:
                  </p>
                  <div className="grid grid-cols-2 gap-2" data-id="element-262">
                    {quickQuestions.map((question, index) => <button key={index} onClick={() => setAiQuestion(question)} className="p-3 text-xs text-left text-purple-600 hover:text-purple-700 bg-purple-50 hover:bg-purple-100 rounded-lg border border-purple-200 transition-colors" data-id="element-263">
                        {question}
                      </button>)}
                  </div>
                </div>
                {/* Chat Input */}
                <div className="flex space-x-2" data-id="element-264">
                  <input type="text" value={aiQuestion} onChange={e => setAiQuestion(e.target.value)} placeholder="Ask Clara about regulations, similar claims..." className="flex-1 p-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" onKeyPress={e => e.key === 'Enter' && sendAiMessage()} data-id="element-265" />
                  <button onClick={sendAiMessage} className="bg-purple-600 text-white p-2 rounded-lg hover:bg-purple-700" data-id="element-266">
                    <Send className="w-4 h-4" data-id="element-267" />
                  </button>
                </div>
              </div>
            </div>
            {/* Quick Actions */}
          </div>
        </div>
      </main>
    </div>;
}